import { Experimentation } from '@alto/experimentation';
import { Platform } from 'react-native';

export type Brand = 'alto' | 'fuzehealth' | 'fuzerx';

/**
 * Get the brand of the current website. Used to determine the correct colors and other branding assets to load.
 * @returns Brand ('alto', 'fuzehealth', or 'fuzerx')
 */
export const getBrand = (): Brand => {
  if (Experimentation.getFeatureValue('fuze_brand_override', false)) {
    return 'fuzerx';
  }

  if (Platform.OS === 'ios' || Platform.OS === 'android') {
    return 'alto';
  }

  const host = window.location.hostname.toLowerCase();

  if (host.includes('alto')) {
    return 'alto';
  }

  if (host.includes('fuzehealth')) {
    return 'fuzehealth';
  }

  throw new Error('Unable to resolve brand');
};
